var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 32 32"}},[_c('circle',{attrs:{"cx":"16","cy":"16","r":"16","fill":"#BEC2C9"}}),_c('circle',{attrs:{"cx":"16","cy":"16","r":"15","fill":"#fff"}}),_c('circle',{attrs:{"cx":"16","cy":"16","r":"13","fill":"currentColor"}})])
}
var staticRenderFns = []

export default { render: render }